import { graphql } from 'gatsby';
import { Badge, Link, Text } from '@chakra-ui/layout';
import { FaExternalLinkAlt } from 'react-icons/fa';
import * as React from 'react';
export default {
  graphql,
  Badge,
  Link,
  Text,
  FaExternalLinkAlt,
  React
};